"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incidents = void 0;
var incidents = {
  	"viewBox": "0 0 600 600",
  	"children": [{
		"name": "path",
		"attribs": {
			"d": "M579.4,241.5c-15.3-75.2-59-140-123.1-182.3C409.1,28,354.4,11.5,298,11.5c-96.9,0-186.6,48.2-240,128.9"+
            "c-42.3,64-57.2,140.7-41.9,215.9c15.3,75.2,59,140,123.1,182.3c47.2,31.2,102,47.7,158.3,47.7c96.9,0,186.6-48.2,240-128.9"+
            "C579.8,393.4,594.7,316.8,579.4,241.5z M297.5,543c-47.8,0-94.3-14-134.4-40.5c-54.4-36-91.5-91-104.5-154.8"+
            "c-11.6-56.7-2.8-114.4,24.5-164.7L206,264.2c-16,28-27.7,55.5-27.7,76.1c0,65.9,53.5,119.4,119.4,119.4c46.2,0,85.8-26.5,105.7-64.9"+
            "l84.8,56.1C442.2,508.8,372.5,543,297.5,543z M512.4,414.9l-96.3-63.7c0.3-3.6,1.1-7.2,1.1-10.9c0-65.9-119.4-202.1-119.4-202.1"+
            "s-36.1,41.3-68.7,89.4l-121.8-80.6C153.4,89.1,223,54.8,298,54.8c47.8,0,94.3,14,134.4,40.5c54.4,36,91.5,91,104.5,154.8"+
            "C548.5,306.9,539.7,364.6,512.4,414.9z",
		}
	}]
};
exports.incidents = incidents;